import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { TranslateKey, useInject } from '@/composables/use-inject';
import AppModal from '@/components/Base/AppModal/AppModal.vue';
import ItemDetails from '@/components/ItemDetails/ItemDetails.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemDetailsModal',
  props: {
  id: {
    type: Number,
    required: true,
  },
  enhancement: {
    type: Number,
    required: true,
  },
},
  emits: {
  close: null,
},
  setup(__props, { emit }) {

const props = __props;





const translate = useInject(TranslateKey);

const triggerItemDetailsModalClose = (): void => {
  emit('close');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppModal, {
    title: _unref(translate)('generic.purchase'),
    fullsize: true,
    onClose: triggerItemDetailsModalClose
  }, {
    default: _withCtx(() => [
      _createVNode(ItemDetails, {
        id: props.id,
        enhancement: props.enhancement
      }, null, 8, ["id", "enhancement"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})